var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"float":"right"}},[_c('v-btn',{attrs:{"color":"primary","small":""},on:{"click":function($event){$event.stopPropagation();return _vm.addnewproduct()}}},[_vm._v("Add Product")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }